export const themeConfig = {
  token: {
    colorPrimary: '#E9602A',
    radiusBase: 4,
    controlRadius: 4,
    colorLink: '#E9602A',
    colorLinkActive: '#E9602A',
    colorLinkHover: '#E9602A',
  },
  components: {
    Typography: {},
    Input: {
      paddingBlock: 8,
      inputFontSize: 14,
      borderRadius: 8,
    },
    Select: {
      controlHeight: 40,
      borderRadius: 8,
    },
    Button: {
      borderRadius: 4,
      borderRadiusSM: 8,
      borderRadiusLG: 8,
      controlHeightSM: 40,
      controlHeight: 40,
      controlHeightLG: 48,
      paddingInlineSM: 16,
      paddingInline: 20,
      paddingInlineLG: 24,
      contentFontSizeSM: 14,
      contentFontSize: 14,
      contentFontSizeLG: 16,
      fontWeight: 600,
      colorBgContainerDisabled: '#F2F4F7',
      defaultBorderColor: '#e9602a',
      defaultColor: 'var(--secondary-btn-text)',
      defaultHoverBg: 'var(--secondary-btn-bg-hover)',
      defaultBg: 'var(--secondary-btn-bg)',
      defaultHoverColor: 'var(--secondary-btn-text)',
      defaultHoverBorderColor: '#e9602a',
      colorPrimary: 'var(--primary-btn-bg)',
      colorPrimaryHover: '#CA491E',
      primaryColor: 'var(--primary-btn-text)',
      colorPrimaryTextActive: '#CA491E',
      colorPrimaryActive: '#CA491E',
      colorPrimaryText: 'var(--primary-btn-text)',
      colorBgSolid: 'var(--primary-btn-bg)',
      colorPrimaryBg: 'var(--primary-btn-bg)',
      colorPrimaryBgHover: 'var(--primary-btn-bg-hover)',
    },
    Menu: { itemSelectedBg: 'var(--color-light-grey)' },
  },
};
